export const SENDING_REQUEST = 'PERMISSIONMATRIX_SENDING_REQUEST';
export const GET_GROUPS_SUCCESS = 'PERMISSIONMATRIX_GET_GROUPS_SUCCESS';
export const GET_CATEGORIES_SUCCESS = 'PERMISSIONMATRIX_GET_CATEGORIES_SUCCESS';
export const FAILURE = 'PERMISSIONMATRIX_FAILURE';
export const SET_VALUE = 'PERMISSIONMATRIX_SET_VALUE';